import { render, staticRenderFns } from "./SectionsListDrawer.vue?vue&type=template&id=47f29e8b"
import script from "./SectionsListDrawer.vue?vue&type=script&lang=js"
export * from "./SectionsListDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports